import Axios from "axios";
import { getToken } from "../backend-api";

// const unchecked_VITE_API_URL = import.meta.env.VITE_API_URL;
const API_URL = import.meta.env.VITE_API_URL || "/api";
const APP_VERSION = import.meta.env.VITE_VERSION;
export const TOKEN_HEADER_KEY = ["x", "-", "w", "e", "ep", "y", "-", "to", "k", "en"].join("");
export const APP_VERSION_HEADER_KEY = [
  "x",
  "-",
  "w",
  "e",
  "e",
  "p",
  "y",
  "-",
  "w",
  "e",
  "ba",
  "p",
  "p",
  "-",
  "v",
  "er",
  "si",
  "on",
].join("");

export class ApiError extends Error {
  constructor(message: string) {
    super();
    this.name = "ApiError";
    this.message = message;
  }
}

export const apiReq = Axios.create({
  baseURL: API_URL,
  // withCredentials: true,
  headers: {
    [APP_VERSION_HEADER_KEY]: APP_VERSION,
  },
});
apiReq.interceptors.request.use((req) => {
  req.headers[TOKEN_HEADER_KEY] = getToken();
  return req;
});
apiReq.interceptors.response.use(
  (res) => res,
  (err) => {
    // console.error('ReqError', err);
    if (err?.response?.data?.must_revalidate) {
      localStorage.clear(); // clear everything including encrypted auth info
      window.location.pathname = "/login";
      throw new Error("must_revalidate");
    }
    if (err?.response?.data?.message) throw new ApiError(err.response.data.message);
    // TODO: detect cloudflare errors
    throw err;
  }
);

const library = {
  item: (item_id: number | string, slug: string) => `/library-item/${item_id}?slug=${slug}`,
};
export const endpoints = {
  library,
  comments: {
    get: (item_id: number | string) => `/library-item/${item_id}/comments`,
    create: (item_id: number) => `/library-item/${item_id}/comment`,
    delete: (comment_id: string) => `/comment/${comment_id}/delete`,
    like: (comment_id: string) => `/comment/${comment_id}/like`,
    unlike: (comment_id: string) => `/comment/${comment_id}/unlike`,
  },
};
